/**
 * Shopifyコレクションフィルター用アコーディオン制御スクリプト
 */
(function() {
    'use strict';

    const filterContainerSelector = '.horizontal-filter__grid';
    const groupSelector = '[class*="collection-sidebar__group--"]';
    const buttonSelector = 'button';
    const contentSelector = '.collapsible-content';

    /**
     * クリック時に他のアコーディオンを閉じる
     */
    document.addEventListener('click', (event) => {
        const filterContainer = event.target.closest(filterContainerSelector);
        if (!filterContainer) {
            return;
        }

        const clickedButton = event.target.closest(`${groupSelector} ${buttonSelector}`);
        if (!clickedButton) {
            return;
        }

        const clickedGroup = clickedButton.closest(groupSelector);
        const allGroups = filterContainer.querySelectorAll(groupSelector);

        allGroups.forEach(group => {
            if (group === clickedGroup) {
                return;
            }

            const button = group.querySelector(buttonSelector);
            const content = group.querySelector(contentSelector);

            button?.classList.remove('is-open');
            button?.setAttribute('aria-expanded', 'false');

            if (content?.classList.contains('is-open')) {
                content.classList.remove('is-open');
                content.style.height = '0';
            }
        });
    });

    /**
     * Ajaxによるコレクション更新後に全てのアコーディオンを閉じる (追加部分)
     */
    document.addEventListener('collection:reloaded', () => {
        setTimeout(() => {
            const filterContainers = document.querySelectorAll(filterContainerSelector);

            filterContainers.forEach(container => {
                const allGroups = container.querySelectorAll(groupSelector);

                allGroups.forEach(group => {
                    const button = group.querySelector(buttonSelector);
                    const content = group.querySelector(contentSelector);

                    // ボタンを閉じた状態に更新
                    button?.classList.remove('is-open');
                    button?.setAttribute('aria-expanded', 'false');

                    // コンテンツエリアを閉じる
                    if (content?.classList.contains('is-open')) {
                        content.classList.remove('is-open');
                        content.style.height = '0';
                    }
                });
            });
        }, 100);
    });
})();
